import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "#90e5fc";
const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    backgroundColor: "#bff0fd",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1,
  },
  description: {
    width: "20%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
 
  recipient: {
    width: "40%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  amount: {
    width: "20%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  serial: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
});

const ReceiptTableHeader = () => (
  <View style={styles.container}>
    <Text style={styles.serial}>ID</Text>
    <Text style={styles.amount}>TIME</Text>
    <Text style={styles.recipient}>RECIPIENT</Text>
    <Text style={styles.amount}>AMOUNT</Text>
    <Text style={styles.description}>STATUS</Text>
  </View>
);

export default ReceiptTableHeader;
